/** The Dashboard's path. It has no URL state since the time series (and its `baseline` switch) was removed. */
export const DASHBOARD_ROUTE = "/dashboard" as const;
